import { render, staticRenderFns } from "./ForestDescription.vue?vue&type=template&id=273b923a&scoped=true&"
import script from "./ForestDescription.vue?vue&type=script&lang=ts&"
export * from "./ForestDescription.vue?vue&type=script&lang=ts&"
import style0 from "./ForestDescription.vue?vue&type=style&index=0&id=273b923a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b923a",
  null
  
)

export default component.exports